export default __webpack_public_path__ + "static/media/bg_podcast_mobile.3eb84041.webp";